import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Stack, Tabs, Title } from '@mantine/core'
import { PageContainer } from '@shared/components/app-shell/page-container/page-container'
import { PAGE_TITLES } from '@/constants/page-titles'
import { UnsoldLots } from '@/pages/offers/unsold-lots/unsold-lots.page'
import { ViewOffers } from '@/pages/offers/view-offers/view-offers.page'
import { useNavigation } from '@/hooks/use-navigation'

export enum OffersTabValue {
  UNSOLD_LOTS = 'unsold-lots',
  VIEW_OFFERS = 'view-offers',
}

export function OffersPage() {
  const { navigateToUnsoldLots, navigateToOffersTab } = useNavigation()
  const { offersTabValue } = useParams()

  // If root offers route, redirect to unsold lots panel by default
  useEffect(() => {
    if (offersTabValue === undefined) {
      navigateToUnsoldLots()
    }
  }, [offersTabValue])

  return (
    <PageContainer title={PAGE_TITLES.OFFERS}>
      <Stack data-testid='offers'>
        <Title>Offers</Title>
        <Tabs
          keepMounted={false}
          defaultValue={OffersTabValue.UNSOLD_LOTS}
          value={offersTabValue}
          onChange={(value) => navigateToOffersTab(value)}
        >
          <Tabs.List mb='md'>
            <Tabs.Tab value={OffersTabValue.UNSOLD_LOTS}>Unsold Lots</Tabs.Tab>
            <Tabs.Tab value={OffersTabValue.VIEW_OFFERS}>View Offers</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value={OffersTabValue.UNSOLD_LOTS}>
            <UnsoldLots />
          </Tabs.Panel>
          <Tabs.Panel value={OffersTabValue.VIEW_OFFERS}>
            <ViewOffers />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </PageContainer>
  )
}
